import React, { useEffect } from 'react';

import { useFormik } from 'formik';

import {
  getRegions,
  pharmacistActions,
  pharmacistRegions,
  successSelector,
  updateRegions,
} from '@pharmaplan/common';

import { Box } from '@mui/material';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../hooks/useAppSelector';

import { ProInfoValidator } from '../../FormValidation';
import ProfileForm from '../../ProfileForm';
import { ICommonProfile } from '../General/General';
import { resetDialog } from '../../../../reducers/dialogReducer';

const initialValues: Array<string> = [];

const ProfessionalInfo = ({ setSelected }: ICommonProfile) => {
  const dispatch = useAppDispatch();
  const regions = useAppSelector(pharmacistRegions);
  const success = useAppSelector((state) =>
    successSelector([pharmacistActions.updateRegions], state));

  const onSubmit = (values: Array<string>) => {
    dispatch(updateRegions(values));
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    enableReinitialize: true,
    validationSchema: ProInfoValidator(),
  });

  const { setValues } = formik ?? {};
  const { selectedRegions } = regions ?? {};

  useEffect(() => {
    dispatch(getRegions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValues(selectedRegions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRegions]);

  useEffect(() => {
    if (success) {
      dispatch(resetDialog());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box px={3} pb={2}>
      <ProfileForm
        setSelected={setSelected}
        selected="geographicAvailability"
        formik={formik}
      />
    </Box>
  );
};

export default ProfessionalInfo;
